<template>
	<div ref="certificate" v-parallax-fit="parallax" class="certificate">
		<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/22_check@2x.png" alt="">
	</div>
</template>

<script>
export default {
	data() {
		return {
			parallax: [
				{
					start: 31100,
					end: 34000,
					fromStyle: { transform: 'translateY(-500%) translateX(0%) rotate(0deg)' },
					toStyle: { transform: 'translateY(0%) translateX(0%) rotate(15deg)' },
					easing: 'linear'
				},
				{
					start: 35000,
					end: 38000,
					fromStyle: { transform: 'translateY(0%) translateX(0%) rotate(15deg)' },
					toStyle: { transform: 'translateY(-500%) translateX(-500%) rotate(180deg)' },
					easing: 'linear'
				}
			]
		}
	},
}
</script>

<style lang="scss" scoped>
.certificate {
	position: absolute;
	top: 0;
	right: 0;
	max-width: 600px;
	width: 100%;
	transition: all 0.5s linear;
	margin-top: 100px;
	margin-right: -170px;
}

@media screen and (max-width: 650px) {
	.certificate {
		max-width: 250px;
		margin-right: -65px;
	}
}
</style>
